<template>

   
     
    <div class="wrapper" >

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            
            <MyProjectComponent></MyProjectComponent>

        </div>
    </div>

</template>

<script>
  
    import MyProjectComponent from '../components/MyProjectComponent2';

    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';
     
    export default {
            
        components: {
            MyProjectComponent, Sidebar
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return {
               
            }
        },
        mounted() {
         

        },
        methods: {
           
             
        }
    };

   

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   #app {height: 100vh;}
     
    .nav-link {
        color: white;
        width: 100%;
    }
    .nav-link.active{
       
    }
</style>

